import ProductDailyReport from './DailyReport';

const Report = () => {
    return <ProductDailyReport />;
};

export default Report;
